export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13631.e1c84280.jpg";